import React, { useState, useEffect } from 'react';
import { Col, Row } from '@flightstats/airframe-react';

import {
  Input,
  FormLabeledInputRowWrapper,
} from '../../components/forms/Input';
import Dropdown from '../../components/Dropdown';
import { BodyCard } from '../components/styledComponent';
import FormButtonRow from '../components/formButtonRow';
import { toTitleCase } from '../../lib/strings';
import { InputType } from './CreateTripGroupContainer';
import { BoxOutlinedGroupedComponents } from '../components/styledComponent';
import MessageDisplay, {
  MessageTypes,
} from '../components/styledComponent/MessageDisplay';
const dropDownValues = [
  {
    value: '',
    text: '[Empty Value]',
  },
  {
    value: 'true',
    text: 'True',
  },
  {
    value: 'false',
    text: 'False',
  },
];

interface CreateTripGroupFormProps {
  name: string;
  setName: (value: string) => void;
  attributes: InputType[];
  onChange: (field: string, value: string) => void;
  onClear: () => void;
  onSave: () => void;
}

export const CreateTripGroupForm: React.FC<CreateTripGroupFormProps> = ({
  name,
  setName,
  attributes,
  onChange,
  onClear,
  onSave,
}) => {
  const [nameError, setNameError] = useState('');
  const [saveDisabled, setSaveDisabled] = useState(true);

  useEffect(() => {
    const trimmedName = name?.trim();
    !trimmedName ? setNameError('Name is required.') : setNameError('');
    setSaveDisabled(!trimmedName);
  }, [name]);

  useEffect(() => {
    setNameError('');
  }, []);

  return (
    <BodyCard>
      <Row>
        <Col style={{ flex: 'unset' }}>
          <FormLabeledInputRowWrapper
            elementId={'name'}
            label={'Name:'}
            width="6rem"
          >
            <Input
              name={'name'}
              value={name}
              onChange={e => {
                setName(e.currentTarget.value);
              }}
              maxLength={128}
            />
            {nameError && (
              <MessageDisplay type={MessageTypes.ERROR}>
                {nameError}
              </MessageDisplay>
            )}
          </FormLabeledInputRowWrapper>
        </Col>
        <Col style={{ flex: 'unset' }}>
          <BoxOutlinedGroupedComponents header="Lineage Attributes">
            {attributes.map(attribute => {
              const attrName = attribute.name;
              if (attribute.type === 'STRING') {
                return (
                  <FormLabeledInputRowWrapper
                    elementId={attrName}
                    label={`${toTitleCase(attrName)}:`}
                    width="95px"
                    key={attrName}
                  >
                    <Input
                      name={attrName}
                      value={attribute.value}
                      onChange={e => {
                        onChange(attrName, e.currentTarget.value);
                      }}
                      maxLength={128}
                    />
                  </FormLabeledInputRowWrapper>
                );
              } else if (attribute.type === 'BOOLEAN') {
                return (
                  <FormLabeledInputRowWrapper
                    elementId={attrName}
                    label={`${toTitleCase(attrName)}:`}
                    width="95px"
                    key={attrName}
                  >
                    <Dropdown
                      id={attrName}
                      options={dropDownValues}
                      value={attribute.value}
                      onChange={value => {
                        onChange(attrName, String(value));
                      }}
                    />
                  </FormLabeledInputRowWrapper>
                );
              }
            })}
          </BoxOutlinedGroupedComponents>
        </Col>
      </Row>
      <FormButtonRow
        onClear={onClear}
        onSubmit={onSave}
        saveDisabled={saveDisabled}
        clearText="CLEAR"
        submitText="SAVE"
      />
    </BodyCard>
  );
};
